<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <global-table
          :table-data="billing_address"
          :loading="loading"
          :per-page="10"
          :bordered="true"
          :table-detail="tableDetail"
          :hover="true"
          :striped="false"
          :fields="fields"
          :row-edit="billingAddressFrom"
          :redirect-detail="false"
          :show-add-button="true"
          caption="<i class='fa fa-align-justify'></i> Alamat Penagihan"
          addButton="Tambah Alamat Penagihan"
          @editForm="editForm"
          @resetForm="resetForm"
        ></global-table>

        <b-modal
          ref="myModalRef"
          id="addModals"
          header-border-variant="no-border text-center"
          footer-border-variant="no-border"
          footer-bg-variant="light"
          :no-close-on-backdrop="true"
          :no-close-on-esc="true"
          size="lg"
        >
          <div slot="modal-header" class="text-center">
            <h3 class="text-center" v-if="!isEdit">Input Group Konsumen Baru</h3>
            <h3 class="text-center" v-else-if="isEdit">Ubah Group Konsumen</h3>
          </div>

          <b-form id="billingAddressFrom" validated novalidate>
            <div v-if="!loadingSubmitModal">
              <b-row>
                <b-col sm="3">
                  <b-form-group label-for="name" label="Alamat Penagihan">
                    <b-form-input
                      id="name"
                      type="text"
                      v-model="$v.billingAddressFrom.name.$model"
                      :state="!$v.billingAddressFrom.name.$invalid"
                      required
                      placeholder="Nama Group"
                    ></b-form-input>
                    <b-form-invalid-feedback>Nama Group harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="6">
                  <b-form-group label-for="address" label="Alamat Lengkap">
                    <b-form-textarea
                      id="address"
                      :rows="3"
                      :max-rows="6"
                      v-model="$v.billingAddressFrom.address.$model"
                      :state="!$v.billingAddressFrom.address.$invalid"
                    ></b-form-textarea>
                    <b-form-invalid-feedback>Alamat lengkap harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
            <div v-else>
              <loading></loading>
            </div>
          </b-form>

          <div slot="modal-footer" class="float-right">
            <div v-if="!loadingSubmitModal">
              <b-button type="button" size="sm" variant="danger" @click="cancelAdd">
                <i class="fa fa-undo"></i> Back
              </b-button>&nbsp;
              <b-button
                type="button"
                size="sm"
                variant="primary"
                @click="saveProcess"
                :disabled="$v.billingAddressFrom.$invalid"
              >
                <i class="fa fa-save"></i> Save
              </b-button>
            </div>
          </div>
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import masterInterfaces from "@/templates/_master_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import { ModelSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";

export default {
  name: "billing_address",
  components: { globalTable, ModelSelect, loading },
  props: {
    tableDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      billing_address: [],
      loading: true,
      loadingSubmitModal: false,
      fields: [
        { key: "name", label: "Nama Alamat Penagihan", sortable: true },
        { key: "address", label: "Alamat Detail" },
        { key: "action", class: "text-center width-80" }
      ],
      billingAddressFrom: masterInterfaces.billing_address,
      isEdit: false
    };
  },
  validations: {
    billingAddressFrom: {
      name: { required },
      address: {}
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  methods: {
    init: function() {
      this.getBillingAddress();
    },
    getBillingAddress: function() {
      this.axios
        .get("web/master/billing_address/all/")
        .then(response => {
          this.billing_address = response.data.data;
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    },
    editForm: function(e) {
      this.isEdit = true;
      this.billingAddressFrom = e;
    },
    resetForm: function() {
      for (var a in masterInterfaces.billing_address) {
        masterInterfaces.billing_address[a] = null;
      }
      this.billingAddressFrom = masterInterfaces.billing_address;
    },
    cancelAdd: function() {
      this.isEdit = false;
      this.$refs.myModalRef.hide();
      this.init();
    },
    saveProcess: function(evt) {
      evt.preventDefault();
      if (this.isEdit) {
        if (confirm("Apakah anda ingin mengubah group konsumen ini?")) {
          this.loadingSubmitModal = true;
          this.axios
            .put("web/master/billing_address/edit/", this.billingAddressFrom)
            .then(response => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Ubah alamat penagihan berhasil",
                  message: response.data.message
                });
              }
            })
            .catch(error => {
              this.expired(error, 'Ubah alamat penagihan');
            })
            .finally(() => {
              this.loadingSubmitModal = false;
              this.cancelAdd();
              this.init();
            });
        }
      } else {
        if (confirm("Apakah anda ingin menambahkan alamat penagihan ini?")) {
          this.loadingSubmitModal = true;
          this.axios
            .post("web/master/billing_address/add/", this.billingAddressFrom)
            .then(response => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Tambah alamat penagihan berhasil",
                  message: response.data.message
                });
              } else {
                this.showErrorNotification({
                  title: "Tambah alamat penagihan gagal",
                  message: response.data.message
                });
              }
            })
            .catch(error => {
              this.expired(error, 'Tambah alamat penagihan');
            })
            .finally(() => {
              this.loadingSubmitModal = false;
              this.cancelAdd();
              this.init();
            });
        }
      }
    },
    expired: function(error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

  